/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Form from 'react-bootstrap/Form';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@material-ui/core';

import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

import {
  checkQuarterValidation,
  handleQuarterFormate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getDefaultMfgData,
  dispatchDefaultMfgData,
  maintainContractActions,
  handleErrorMessages,
  getCommonDropdownList,
} from '../store/actions';

const ContractManufacturer = ({ isEnablebyRole = true }) => {
  const dispatch = useDispatch();
  const getAllContractData = useSelector(
    (state) => state.sharedState.ContractReducer.getAllContractData
  );
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer.searchContractState
  );
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const defaultMfgDataDataForContract = useSelector((state) => {
    return state.sharedState.ContractReducer?.defaultMfgDataDataForContract;
  });
  const manufacturerDetail = useSelector((state) => {
    return state.sharedState.ContractReducer?.maintainContractState
      ?.manufacturerTab;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const [commonDropdownList, setCommonDropdownList] = useState({});
  const [open, setOpen] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  // on load of the manufacturer tab
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: [
        'ENROLLMENT_TIMING_CD',
        'PRICING_TIMING_CD',
        'COLLECTION_MEDIUM_CD',
      ],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // Getting the response  of Default Mgf indicator service
  React.useEffect(() => {
    if (manufacturerDetail?.useDefMfgInd === 1) {
      let localErr = errorMessagesFromRedux || [];
      const newObj = defaultMfgDataDataForContract;
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          manufacturerTab: {
            ...manufacturerDetail,
            paperFinalQtr: handleQuarterFormate(newObj.defPaperFinalQtr) || '',
            printImageFinalQtr:
              handleQuarterFormate(newObj.defPrintImageFinalQtr) || '',
            cmsElectFinalQtr:
              handleQuarterFormate(newObj.defCmsElectFinalQtr) || '',
            ncpdpSummaryFinalQtr:
              handleQuarterFormate(newObj.defNcpdpSummaryFinalQtr) || '',
            ncpdpClaimOwnFinalQtr:
              handleQuarterFormate(newObj.defNcpdpClaimOwnFinalQtr) || '',
            ncpdpClaimMbFinalQtr:
              handleQuarterFormate(newObj.defNcpdpClaimMbFinalQtr) || '',
            paperInd: newObj.defPaperInd || 0,
            printImageInd: newObj.defPrintImageInd || 0,
            cmsElectInd: newObj.defCmsElectInd || 0,
            ncpdpSummaryInd: newObj.defNcpdpSummaryInd || 0,
            ncpdpClaimOwnInd: newObj.defNcpdpClaimOwnInd || 0,
            ncpdpClaimMbInd: newObj.defNcpdpClaimMbInd || 0,
            pricingTimingCd: newObj.defPricingTimingCd || '-1',
            enrollmentTimingCd: newObj.defEnrollmentTimingCd || '-1',
            collectionMediumCd: newObj.defCollectionMediumCd || '-1',
          },
        })
      );
      localErr = localErr?.filter((item) => item.tabName !== 'Manufacturer');
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  }, [defaultMfgDataDataForContract]);
  // Pop up of Default MFG indicator
  const handleFetchMFGDetail = () => {
    setOpen(false);
    dispatch(
      getDefaultMfgData({
        mfgId:
          searchContractState.contractType === 'onSelect'
            ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                ?.mfgId
            : searchContractState.selectedRowData,
        rebateProgramCd: null,
      })
    );
  };
  const toDropdownValue = (value) =>
    value != null && value !== '' ? String(value) : '-1';
  const mapContractManufacturerOverrides = (newObj, useDefMfgInd) => ({
    useDefMfgInd,
    paperFinalQtr: handleQuarterFormate(newObj?.paperFinalQtr) || '',
    printImageFinalQtr: handleQuarterFormate(newObj?.printImageFinalQtr) || '',
    cmsElectFinalQtr: handleQuarterFormate(newObj?.cmsElectFinalQtr) || '',
    ncpdpSummaryFinalQtr:
      handleQuarterFormate(newObj?.ncpdpSummaryFinalQtr) || '',
    ncpdpClaimOwnFinalQtr:
      handleQuarterFormate(newObj?.ncpdpClaimOwnFinalQtr) || '',
    ncpdpClaimMbFinalQtr:
      handleQuarterFormate(newObj?.ncpdpClaimMbFinalQtr) || '',
    paperInd: newObj?.paperInd ?? 0,
    printImageInd: newObj?.printImageInd ?? 0,
    cmsElectInd: newObj?.cmsElectInd ?? 0,
    ncpdpSummaryInd: newObj?.ncpdpSummaryInd ?? 0,
    ncpdpClaimOwnInd: newObj?.ncpdpClaimOwnInd ?? 0,
    ncpdpClaimMbInd: newObj?.ncpdpClaimMbInd ?? 0,
    pricingTimingCd: toDropdownValue(newObj?.pricingTimingCd),
    enrollmentTimingCd: toDropdownValue(newObj?.enrollmentTimingCd),
    collectionMediumCd: toDropdownValue(newObj?.collectionMediumCd),
  });

  // set default values initial
  const handleSetDefaultValues = (value, clearUseDefMfgInd = false) => {
    if (!value && searchContractState?.contractType == 'onSelect') {
      const newObj =
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab;
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          manufacturerTab: {
            ...manufacturerDetail,
            ...mapContractManufacturerOverrides(
              newObj,
              clearUseDefMfgInd ? 0 : newObj?.useDefMfgInd ?? 0
            ),
          },
        })
      );
    } else {
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          manufacturerTab: {
            ...manufacturerDetail,
            useDefMfgInd: 0,
            paperFinalQtr: '',
            printImageFinalQtr: '',
            cmsElectFinalQtr: '',
            ncpdpSummaryFinalQtr: '',
            ncpdpClaimOwnFinalQtr: '',
            ncpdpClaimMbFinalQtr: '',
            useDefRpcInd: 0,
            paperInd: 0,
            printImageInd: 0,
            cmsElectInd: 0,
            ncpdpSummaryInd: 0,
            ncpdpClaimOwnInd: 0,
            ncpdpClaimMbInd: 0,
            pricingTimingCd: '-1',
            enrollmentTimingCd: '-1',
            collectionMediumCd: '-1',
          },
        })
      );
    }
  };
  const initialDefaultMfgLoaded = React.useRef(false);
  // Load manufacturer defaults once when contract already uses manufacturer defaults
  React.useEffect(() => {
    const header = getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab;
    if (
      !initialDefaultMfgLoaded.current &&
      searchContractState.contractType === 'onSelect' &&
      header?.useDefMfgInd === 1 &&
      header?.mfgId
    ) {
      initialDefaultMfgLoaded.current = true;
      dispatch(
        getDefaultMfgData({
          mfgId: header.mfgId,
          rebateProgramCd: null,
        })
      );
    }
  }, [getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab]);

  // Getting the response  of contract data
  React.useEffect(() => {
    if (getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab) {
      handleSetDefaultValues(false);
    }
  }, [getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab]);

  // call on change event filed level
  const handleOnChangeEvent = (e, name) => {
    // Prevent state changes if isEnablebyRole is false
    if (isEnablebyRole === false) {
      e.preventDefault();
      return;
    }
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
        manufacturerTab: {
          ...manufacturerDetail,
          [name]: e.target.value,
        },
      })
    );
  };
  // call on click event check Box filed level
  const handleOnChangeForCheckBox = (e, name) => {
    // Prevent state changes if isEnablebyRole is false
    if (isEnablebyRole === false) {
      e.preventDefault();
      return;
    }
    if (name === 'useDefMfgInd' && e.target.checked) {
      setOpen(true);
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
          manufacturerTab: {
            ...manufacturerDetail,
            [name]: e.target.checked ? 1 : 0,
          },
        })
      );
    } else if (name === 'useDefMfgInd' && !e.target.checked) {
      const newObj =
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab;
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
          manufacturerTab: {
            ...manufacturerDetail,
            ...mapContractManufacturerOverrides(newObj, 0),
          },
        })
      );
      dispatch(dispatchDefaultMfgData({}));
    } else {
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
          manufacturerTab: {
            ...manufacturerDetail,
            [name]: e.target.checked ? 1 : 0,
          },
        })
      );
    }
  };
  // check validation for filed Level
  const handleOnBlurEventOnFields = (value, name) => {
    // Prevent state changes if isEnablebyRole is false
    if (isEnablebyRole === false) {
      return;
    }
    let localErr = errorMessagesFromRedux || [];
    if (value !== '') {
      if (checkQuarterValidation(value)) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            showSaveButton: 'Yes',
            manufacturerTab: {
              ...manufacturerDetail,
              [name]: value?.toUpperCase(),
            },
          })
        );
      } else {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'invalidQuarterFormat',
          tabName: 'Manufacturer',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  // set common dropdown menu value
  const RenderDropDownFields = (items) => {
    return (
      <TextField
        id={items.id}
        data-testid='RenderDropDownFields'
        name={items.name}
        label={items.label}
        disabled={items.disabled || isEnablebyRole === false}
        fullWidth
        select
        placeholder=''
        inputProps={{ maxLength: 11, id: items.id }}
        InputLabelProps={{ shrink: true }}
        value={items.value}
        onChange={(e) => {
          handleOnChangeEvent(e, items.name);
        }}
      >
        <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
        {items.options && items.options.length > 0
          ? items.options.map((item) => {
              return (
                <MenuItem
                  key={item.codeValueID && item.codeValueID.codeValue}
                  value={item.codeValueID && item.codeValueID.codeValue}
                >
                  {`${item.codeValueID && item.codeValueID.codeValue}-${
                    item.shortDescription
                  }`}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    );
  };
  // handing view History popup
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CONTRACT_SEQ_NUM:
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractSeqNum,
    });
  };
  return (
    <div className='tBillPanel' data-testid='ContractManufacturer-component'>
      <div className='panel tBillPanel-space pb-0'>
        {searchContractState.contractType === 'onSelect' ? (
          <div className='float-right th-icon-group mt-2'>
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='history-tooltip'>View History</Tooltip>}
            >
              <div
                className='th-icon ic-history frr-lab-diff-action-icon-container'
                role='button'
                data-testid='view-history'
                tabIndex='0'
                onClick={() => {
                  handleViewHistory();
                }}
              >
                <span className='ic-title'> History </span>
              </div>
            </OverlayTrigger>
          </div>
        ) : null}
      </div>
      <Form>
        <div className='mt-3'>
          <div className='row'>
            <div className='col-6'>
              <Form.Group className='mb-3 ' controlId='formBasicCheckbox'>
                <FormControlLabel
                  control={<Checkbox color='primary' />}
                  data-testid='manufacturer-checkbox'
                  id='manufacturer-checkbox'
                  label='Use Manufacturer Defaults'
                  checked={manufacturerDetail?.useDefMfgInd === 1}
                  value={manufacturerDetail?.useDefMfgInd === 1}
                  disabled={isEnablebyRole === false}
                  onChange={(e) => handleOnChangeForCheckBox(e, 'useDefMfgInd')}
                />
              </Form.Group>
            </div>
          </div>
          <div className='tab-body '>
            <fieldset className='custom-fieldset custom-height'>
              <legend>Defaults</legend>
              <div className='row'>
                <div className='col-12 col-sm-5 col-md-4'>
                  <div className='col-sm'>
                    <fieldset className='custom-fieldset custom-height'>
                      <legend>Timing Codes</legend>
                      <div className='form-wrapper db'>
                        <div className='mui-custom-form with-select input-md '>
                          <RenderDropDownFields
                            data-testid='Enrollment'
                            label='Enrollment'
                            id='Enrollment'
                            name='enrollmentTimingCd'
                            disabled={manufacturerDetail?.useDefMfgInd === 1}
                            value={manufacturerDetail?.enrollmentTimingCd}
                            options={commonDropdownList?.ENROLLMENT_TIMING_CD}
                          />
                        </div>
                        <div className='mui-custom-form with-select input-md override-width-95'>
                          <RenderDropDownFields
                            data-testid='Price'
                            label='Price'
                            id='Price'
                            name='pricingTimingCd'
                            disabled={manufacturerDetail?.useDefMfgInd === 1}
                            value={manufacturerDetail?.pricingTimingCd}
                            options={commonDropdownList?.PRICING_TIMING_CD}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className='col-sm'>
                    <div className='mui-custom-form with-select input-md '>
                      <RenderDropDownFields
                        data-testid='collectionMediumCd'
                        label='Collection Medium'
                        id='collectionMediumCd'
                        name='collectionMediumCd'
                        // disabled={manufacturerDetail?.useDefMfgInd === 1}
                        value={manufacturerDetail?.collectionMediumCd}
                        options={commonDropdownList?.COLLECTION_MEDIUM_CD}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-12 col-sm-7 col-md-8 frr-desired-output'>
                  <fieldset
                    className='custom-fieldset px-0'
                    style={{ height: 'auto' }}
                  >
                    <legend className='same-font-family'>
                      Desired Outputs
                    </legend>
                    <div className='form-wrapper chk-input px-4'>
                      <div className='row'>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3'
                            data-testid='Paper'
                            control={<Checkbox color='primary' />}
                            label='Paper'
                            checked={manufacturerDetail?.paperInd === 1}
                            value={manufacturerDetail?.paperInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'paperInd');
                            }}
                          />
                          <TextField
                            data-testid='DEF_PAPER_FINAL'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            id='DEF_PAPER_FINAL_QTR'
                            label='Paper'
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'DEF_PAPER_FINAL_QTR',
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={manufacturerDetail?.paperFinalQtr}
                            disabled={
                              manufacturerDetail?.paperInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'paperFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'paperFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'paperFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'paperFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'paperFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3'
                            control={<Checkbox color='primary' />}
                            controlId='formBasicCheckbox'
                            type='checkbox'
                            id='cms-checkbox'
                            data-testid='cms-checkbox'
                            label=' CMS Format Electronic File'
                            checked={manufacturerDetail?.cmsElectInd === 1}
                            value={manufacturerDetail?.cmsElectInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'cmsElectInd');
                            }}
                          />
                          <TextField
                            data-testid='CMS-Format-electronic-File-Final-Quarter'
                            id='CMS-Format-electronic-File-Final-Quarter'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            label=' CMS-Format-electronic-File-Final-Quarter '
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'CMS-Format-electronic-File-Final-Quarter',
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={manufacturerDetail?.cmsElectFinalQtr}
                            disabled={
                              manufacturerDetail?.cmsElectInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'cmsElectFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'cmsElectFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'cmsElectFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'cmsElectFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'cmsElectFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3 '
                            control={<Checkbox color='primary' />}
                            controlId='formBasicCheckbox'
                            type='checkbox'
                            id='ncdp-checkbox'
                            data-testid='ncdp-checkbox'
                            label=' NCPDP Summary'
                            checked={manufacturerDetail?.ncpdpSummaryInd === 1}
                            value={manufacturerDetail?.ncpdpSummaryInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'ncpdpSummaryInd');
                            }}
                          />
                          <TextField
                            data-testid='NCPDP-Summary-Final-Quarter'
                            id='NCPDP-Summary-Final-Quarter'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            label=' NCPDP-Summary-Final-Quarter '
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'NCPDP-Summary-Final-Quarter',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={manufacturerDetail?.ncpdpSummaryFinalQtr}
                            disabled={
                              manufacturerDetail?.ncpdpSummaryInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'ncpdpSummaryFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'ncpdpSummaryFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpSummaryFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'ncpdpSummaryFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpSummaryFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3 '
                            control={<Checkbox color='primary' />}
                            controlId='formBasicCheckbox'
                            type='checkbox'
                            id='claims-checkbox'
                            data-testid='claims-checkbox'
                            label=' NCPDP Own Claims Detail'
                            checked={manufacturerDetail?.ncpdpClaimOwnInd === 1}
                            value={manufacturerDetail?.ncpdpClaimOwnInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'ncpdpClaimOwnInd');
                            }}
                          />
                          <TextField
                            data-testid='NCPDP-Own-Claims-Detail-Final-Quarter'
                            id='NCPDP-Own-Claims-Detail-Final-Quarter'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            label=' NCPDP-Own-Claims-Detail-Final-Quarter '
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'NCPDP-Own-Claims-Detail-Final-Quarter',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={manufacturerDetail?.ncpdpClaimOwnFinalQtr}
                            disabled={
                              manufacturerDetail?.ncpdpClaimOwnInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'ncpdpClaimOwnFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'ncpdpClaimOwnFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpClaimOwnFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'ncpdpClaimOwnFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpClaimOwnFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3 '
                            control={<Checkbox color='primary' />}
                            controlId='formBasicCheckbox'
                            type='checkbox'
                            data-testid='ncdp-market-checkbox'
                            id='ncdp-market-checkbox'
                            label=' NCPDP Market Basket Claims Detail'
                            checked={manufacturerDetail?.ncpdpClaimMbInd === 1}
                            value={manufacturerDetail?.ncpdpClaimMbInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'ncpdpClaimMbInd');
                            }}
                          />
                          <TextField
                            data-testid='NCPDP-Market-Basket-Claims-Detail-Final-Quarter'
                            id='NCPDP-Market-Basket-Claims-Detail-Final-Quarter'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            label=' NCPDP-Market-Basket-Claims-Detail-Final-Quarter '
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'NCPDP-Market-Basket-Claims-Detail-Final-Quarter',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={manufacturerDetail?.ncpdpClaimMbFinalQtr}
                            disabled={
                              manufacturerDetail?.ncpdpClaimMbInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'ncpdpClaimMbFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'ncpdpClaimMbFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpClaimMbFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'ncpdpClaimMbFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName ===
                                            'ncpdpClaimMbFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                        <div className='mui-custom-form input-md field-md'>
                          <FormControlLabel
                            className='mb-3 pb-1'
                            control={<Checkbox color='primary' />}
                            controlId='formBasicCheckbox'
                            type='checkbox'
                            id='printimage-checkbox'
                            data-testid='printimage-checkbox'
                            label=' Print Image'
                            checked={manufacturerDetail?.printImageInd === 1}
                            value={manufacturerDetail?.printImageInd === 1}
                            disabled={manufacturerDetail?.useDefMfgInd === 1 || isEnablebyRole === false}
                            onClick={(e) => {
                              handleOnChangeForCheckBox(e, 'printImageInd');
                            }}
                          />
                          <TextField
                            data-testid='Print-Image-Final-Quarter'
                            id='Print-Image-Final-Quarter'
                            className='manufacture-margin mandate-fields frr-display-hidden-label'
                            label='Print-Image-Final-Quarter  '
                            fullWidth
                            placeholder=''
                            inputProps={{
                              maxLength: 6,
                              id: 'Print-Image-Final-Quarter',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={manufacturerDetail?.printImageFinalQtr}
                            disabled={
                              manufacturerDetail?.printImageInd !== 1 ||
                              manufacturerDetail?.useDefMfgInd === 1 ||
                              isEnablebyRole === false
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'printImageFinalQtr');
                            }}
                            onBlur={(e) => {
                              handleOnBlurEventOnFields(
                                e.target.value,
                                'printImageFinalQtr'
                              );
                            }}
                            helperText={
                              errorMessagesFromRedux?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'printImageFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              errorMessagesFromRedux?.length > 0 &&
                              errorMessagesFromRedux?.filter((x) => {
                                return x.fieldName === 'printImageFinalQtr';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      errorMessagesFromRedux
                                        ?.filter((x) => {
                                          return (
                                            x.fieldName === 'printImageFinalQtr'
                                          );
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </fieldset>
          </div>
          <CommonModal
            open={open}
            viewAction
            viewHeader
            className='dialogPanel frr-rightAlignment custom-check dialog-500'
            onOk={() => handleFetchMFGDetail()}
            okTitle='Ok'
            onClose={() => {
              setOpen(false);
              handleSetDefaultValues(false, true);
            }}
            closeTitle='Cancel'
            modalTitle='Manufacturer overrides '
            childrenComponent={
              <div>
                <p>
                  Any data in the Manufacturer Overrides section will be
                  replaced by the Manufacturer defaults. Do you wish to proceed?
                </p>
              </div>
            }
          />
        </div>
      </Form>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CONTRACT'
          keyValue={keyValue}
          columnNames='USE_DEF_MFG_IND,ENROLLMENT_TIMING_CD,PRICING_TIMING_CD,COLLECTION_MEDIUM_CD,PAPER_IND,PAPER_FINAL_QTR,CMS_ELECT_IND,CMS_ELECT_FINAL_QTR,NCPDP_SUMMARY_IND,NCPDP_SUMMARY_FINAL_QTR,NCPDP_CLAIM_OWN_IND,NCPDP_CLAIM_OWN_FINAL_QTR,NCPDP_CLAIM_MB_IND,NCPDP_CLAIM_MB_FINAL_QTR,PRINT_IMAGE_IND,PRINT_IMAGE_FINAL_QTR'
        />
      )}
    </div>
  );
};
export default ContractManufacturer;
